"use client"

import type { MouseEvent, ReactElement, ReactNode } from "react"
import { cloneElement, isValidElement } from "react"

import { useOpenAppointmentBooking } from "@/lib/hooks/use-appointment-booking-url"

type AppointmentBookingTriggerProps = {
  children: ReactNode
  serviceIds?: number[]
  serviceSlugs?: string[]
  step?: number
}

export function AppointmentBookingTrigger({
  children,
  serviceIds,
  serviceSlugs,
  step = 1,
}: AppointmentBookingTriggerProps) {
  const openBooking = useOpenAppointmentBooking()

  const handleClick = (event: MouseEvent) => {
    event.preventDefault()
    openBooking({ serviceIds, serviceSlugs, step })
  }

  if (isValidElement(children)) {
    return cloneElement(children as ReactElement<{ onClick?: (e: MouseEvent) => void }>, {
      onClick: (event: MouseEvent) => {
        handleClick(event)
        const childOnClick = (children as ReactElement<{ onClick?: (e: MouseEvent) => void }>)
          .props.onClick
        childOnClick?.(event)
      },
    })
  }

  return (
    <button type="button" onClick={handleClick}>
      {children}
    </button>
  )
}
